export enum Basketball3x3StatId {
  FoulBonus = 73,
}
